import AppRoutes from "./routes/AppRoutes";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import TopContactBar from "./components/layout/TopContactBar";
import "./styles/global.css";
import "./styles/Responsive.css";

function App() {
  return (
    <>
      <TopContactBar />   {/* ✅ TOP BAR everywhere */}
      <Navbar />          {/* ✅ HEADER everywhere */}
      <AppRoutes />
      <Footer />          {/* ✅ FOOTER everywhere */}
    </>
  );
}

export default App;